export const getSimpleSummaryBarStyle = () => ({
  '@global': {
    '.summary-bar-breadcrumb': {
      position: 'relative',
      '& .summary-bar-tag': {
        position: 'absolute',
        display: 'block',
        top: '6px',
        right: '-40px',
      },
    },
  },
});
